import React from 'react';
import WordsAndSpelling from '../words-and-spelling';
import GraphicOrganizer from '../graphic-organizer';
import Vocabulary from '../vocabulary';
import Sentence from '../sentence';
import SequenceGraphicOrganizer from '../sequence-graphic-organizer';
import StoryOrganizer from '../story-organizer';
import MyOpinion from '../my-opinion';
import WordCards from '../word-cards';
import NameLabels from '../name-labels';
import NameTracing from '../name-tracing';
import CompletionCertificate from '../completion-certificate';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

/** Key is sheetId */
const Map = {
  30: {
    name: 'wordsAndSpelling',
    Component: props => <WordsAndSpelling {...props} isCursive />
  },
  31: {
    name: 'vocabulary',
    Component: props => <Vocabulary {...props} isCursive />
  },
  311: {
    name: 'sentence',
    Component: props => <Sentence {...props} isCursive />
  },
  32: {
    name: 'sequenceGraphicOrganizer',
    Component: props => <SequenceGraphicOrganizer {...props} isCursive />
  },
  33: {
    name: 'Graphic Organizer',
    Component: props => <GraphicOrganizer {...props} isCursive />
  },
  34: {
    name: 'Story Organizer',
    Component: props => <StoryOrganizer {...props} isCursive />
  },
  35: {
    name: 'My Opinion',
    Component: props => <MyOpinion {...props} isCursive />
  },
  36: {
    name: 'Word Cards',
    Component: props => <WordCards {...props} isCursive />
  },
  37: {
    name: 'Word Tags',
    Component: props => <NameLabels {...props} isCursive />
  },
  38: {
    name: 'Name Tags',
    Component: props => <NameTracing {...props} isCursive />
  },
  380: {
    name: 'certificateOfCompletionBand',
    Component: props => (
      <CompletionCertificate
        {...props}
        images={[
          {
            name: 'sailboat',
            width: 325,
            height: 240
          }
        ]}
        completedTitle={t('cursiveKickoff')}
        isCursive
      />
    )
  }
};

export default Map;
